import { FC } from "react";
import WarehouseWebLayout from "./WebLayout";

const Warehouse: FC = () => {
  return (
    <div>
      <WarehouseWebLayout />
    </div>
  );
};

export default Warehouse;
